import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  noGradient?: boolean; 
}

export const Input: React.FC<InputProps> = ({ className = '', noGradient = false, ...props }) => {
  const base = 'mm-input';
  const optOut = noGradient ? 'no-gradient' : '';
  return (
    <input
      {...props}
      className={`${base} ${optOut} ${className}`.trim()}
    />
  );
};